<template>
  <div class="od-card-container flex-1">
    <div class="odc-header-container">
      <div class="odc-header">
        Shipping Address
      </div>
      <button
        class="edit-btn"
        @click="toggleActionModal(true, 'update-shipping-address')"
      >
        EDIT
      </button>
    </div>
    <div class="odc-body-container">
      <div class="odcb-info-container">
        <div class="odcb-body">
          {{ order.orderLines[0].shippingAddress.firstName }}
          {{ order.orderLines[0].shippingAddress.lastName }}
        </div>
        <div class="odcb-body">
          {{ order.orderLines[0].shippingAddress.address1 }}
        </div>
        <div
          v-if="order.orderLines[0].shippingAddress.address2"
          class="odcb-body"
        >
          {{ order.orderLines[0].shippingAddress.address2 }}
        </div>
        <div class="odcb-body">
          {{ order.orderLines[0].shippingAddress.city }},
          {{ order.orderLines[0].shippingAddress.state }}
          {{ order.orderLines[0].shippingAddress.zip }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import partnerReviewMixin from '@shared/mixins/partnerReviewMixin';

export default {
  name: 'ShippingInformation',
  mixins: [partnerReviewMixin],
};
</script>
